<template>
    <div class="spin-wheel__knob">

        <svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" viewBox="0 0 82 82" fill="none">
            <g>
                <circle cx="41" cy="41" r="28" fill="white" stroke="white" stroke-width="2" />
                <rect x="16" y="16" width="50" height="50" rx="25" fill="url(#paint0_linear_8467_669)" />
                <rect x="18" y="18" width="46" height="46" rx="23" stroke="url(#paint1_linear_8467_669)"
                    stroke-width="4" />
            </g>
            <rect x="33" y="33" width="16" height="16" rx="8" fill="white" />
            <defs>
                <linearGradient id="paint0_linear_8467_669" x1="16" y1="53.5" x2="16" y2="53.5"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#F45484" />
                    <stop offset="1" stop-color="#F51E78" />
                </linearGradient>
                <linearGradient id="paint1_linear_8467_669" x1="41" y1="16" x2="41" y2="41"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" stop-opacity="0.3" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    </div>
</template>